import { useCallback, useState } from 'react';
import { IDetailsFormData } from '../types/IDetailsFormData';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { useMyBookingsStore } from '../../../../domain/booking/stores/useMyBookingsStore';
import { useNavigate } from '../../../../../shared/router/useNavigate';
import { NewVehicle } from '../../../../../shared/api/gateway/types/NewVehicle';
import { useVehicleStores } from '../../../../../account/vehicles/domain/stores/useVehicleStores';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { EVENT_LABEL_VEHICLES_PARKING_MODIFY } from '../../../../../shared/analytics';
import { trackAddVehicle } from '../../../../../account/vehicles/shared/analytics';

export function useHandleSubmitPartialAmend(
	booking: IBooking | undefined,
	nextUrl: string,
) {
	const { t } = useTranslation();

	const navigate = useNavigate();
	const store = useMyBookingsStore();
	const { getVehicleStore, addVehicleStore } = useVehicleStores();
	const [error, setError] = useState<Error | undefined>();

	const handleSubmit = useCallback(
		async (data: IDetailsFormData) => {
			if (!booking) {
				setError(new Error('No booking provided'));
				return;
			}

			const { licensePlateNumber, saveVehicle } = data;

			try {
				await store.updateBookingDetails(booking, data);

				if (saveVehicle && licensePlateNumber) {
					const currentVehicles = getVehicleStore.value || [];

					const newVehicle: NewVehicle = {
						description: `${t('add_vehicle_empty_description')} ${
							currentVehicles.length + 1
						}`,
						licensePlate: licensePlateNumber,
						favorite: currentVehicles.length === 0,
					};

					addVehicleStore.load(newVehicle);
					trackAddVehicle(EVENT_LABEL_VEHICLES_PARKING_MODIFY);
				}

				navigate(nextUrl);
			} catch (reason) {
				if (reason instanceof Error) {
					setError(reason);
				} else {
					setError(new Error('An unknown error occurred'));
				}
			}
		},
		[booking],
	);

	return { handleSubmit, error };
}
